import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    security = {
        o: 'allow',
    },
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.setMySecurity, {
        security,
    }, options);
    if (error) return { error, status };
    return content || {};
};
